module.exports = __webpack_public_path__ + "static/media/product-4.db4ea5e5.png";